// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonLoaderForHeading_skeleton__VeEsa","loading":"SkeletonLoaderForHeading_loading__+U6XA","h4_skeleton":"SkeletonLoaderForHeading_h4_skeleton__5itbG"};